import * as React from "react"
import styled from "@emotion/styled"

export const AddressWrapper = styled.div(({theme}) => ({
    background: theme.colors.N20,
    borderRadius: 4,
    padding: 24,
    marginBottom: 24,
    "& p": {
        marginBottom: "0 !important"
    },
    [theme.breakpoint.up('md')]: {
        marginBottom: 16,
    }
}))

export const EmailWrapper = styled.div(({theme}) => ({
    background: theme.colors.Y400,
    borderRadius: 4,
    color: "white",
    padding: 16,
    textAlign: "center",
    marginBottom: "16px !important",
    "& p": {
        marginBottom: "0 !important"
    },
    "& p+p": {
        marginTop: 4
    }
}))

export const StyledH2 = styled.h2(({theme}) => ({
    marginTop: 16,
    [theme.breakpoint.up('md')]: {
        marginTop: 24,
    }
}))

export const StyledLink = styled.a(({theme}) => ({
    color: "#0641A6",
    textDecoration: "none",
}))
